"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUrsa = exports.isLight = void 0;
const isUrsa = themeMode => {
  return themeMode.startsWith("ursa");
};
exports.isUrsa = isUrsa;
const isLight = themeMode => {
  return themeMode.endsWith("light");
};
exports.isLight = isLight;
//# sourceMappingURL=themeHelper.js.map